const Dashboard = () => {
    return ( "<p>dashboard</p>" );
}
 
export default Dashboard;